<template>
    <div>
        <b-modal id="editMaterialTarget"
                 title="Редактирование объема материалов"
                 @ok="submit"
                 @hide="clearForm"
                 ok-title="Ок"
                 ok-variant="success"
                 cancel-title="Отмена"
                 cancel-variant="danger"
                 no-close-on-backdrop
                 @show="beforeOpen"
        >
            <label for="object">Строительный объект</label>
            <v-select
                    id="object"
                    label="object_name"
                    value="building_process_id"
                    :options="objects"
                    v-model="selectedObject">
            </v-select>

            <label for="workTarget">Работы по объекту</label>
            <v-select
                    id="workTarget"
                    label="work_name"
                    value="target_works_id"
                    :options="workTargets"
                    v-model="selectedWorkTarget">
            </v-select>

            <label for="material">Материал</label>
            <b-form-input
                    id="material"
                    :value="selectedMaterial && selectedMaterial.name"
                    size="sm"
                    disabled
            ></b-form-input>

            <b-alert v-if="workTargetScopeLabel" show variant="info" class="mt-3 py-2">
                Количество материала указывается на весь объём работы:
                <strong>{{ workTargetScopeLabel }}</strong>
            </b-alert>

            <label for="value">Количество материала</label>
            <b-input-group size="sm">
                <b-form-input
                        v-model="value"
                        id="value"
                        type="number"
                ></b-form-input>
                <b-input-group-append v-if="selectedMaterialUnit">
                    <b-input-group-text class="font-weight-bold">
                        {{ selectedMaterialUnit }}
                    </b-input-group-text>
                </b-input-group-append>
            </b-input-group>

            <label for="value">Тревога сработает если отклонение превысит:</label>
            <b-form-input
                    v-model="limit"
                    id="limit"
                    size="sm"
                    type="number"
            ></b-form-input>
        </b-modal>
    </div>
</template>

<script>
    export default {
        computed: {
            materials() {
                return this.$store.state.materials.directory;
            },
            objects() {
                return this.$store.state.objectsInProcess;
            },
            selectedMaterialTargetId() {
                return this.$store.state.materials.selectedMaterialTargetId;
            },
            workTargets() {
                if (!this.selectedObject) {
                    return [];
                }
                const {building_process_id} = this.selectedObject;
                return this.$store.state.targets.filter(el => el.building_process_id === building_process_id);
            },
            selectedMaterialUnit() {
                return this.selectedMaterial && (
                    this.selectedMaterial.measures || this.selectedMaterial.unit
                ) || ``;
            },
            workTargetScopeLabel() {
                const target = this.selectedWorkTarget;
                if (!target) return ``;
                const name = target.work_name_project || target.work_name
                    || target.target_work_name || `Работа`;
                const rawValue = target.target_work_value !== undefined
                    ? target.target_work_value
                    : target.value;
                const number = Number(rawValue);
                const amount = Number.isFinite(number)
                    ? number.toLocaleString(`ru-RU`)
                    : (rawValue || `объём не указан`);
                const unitValue = target.target_work_measures
                    || target.unit_of_measurement || ``;
                return `${name} — ${amount}${unitValue ? ` ${unitValue}` : ``}`;
            }
        },
        data() {
            return {
                selectedMaterial: null,
                selectedObject: null,
                selectedWorkTarget: null,
                value: 0,
                limit: 0
            }
        },
        methods: {
            clearForm() {
                this.selectedMaterial = null;
                this.selectedObject = null;
                this.selectedWorkTarget = null;
                this.value = null;
                this.limit = null;
            },
            async beforeOpen() {
                this.$store.dispatch(`getObjectsInProcess`);
                this.$store.dispatch(`getTargets`);
                this.$store.dispatch(`getDirectory`);
                const target = await this.$store.dispatch(`getMaterialTarget`, this.selectedMaterialTargetId);
                this.setTarget(target);
            },
            setTarget({
                building_process_id,
                material_id,
                material_name,
                measures,
                target_work_id,
                target_work_value,
                target_work_measures,
                value,
                limit,
                object_name,
                target_work_name
            }) {
                this.selectedMaterial = {
                    id: material_id,
                    name: material_name,
                    measures
                };
                this.selectedObject = {
                    building_process_id,
                    object_name
                }
                this.selectedWorkTarget = {
                    target_works_id: target_work_id,
                    work_name: target_work_name,
                    target_work_value,
                    target_work_measures
                };
                this.value = value;
                this.limit = limit;
            },
            submit() {
                const data = {
                    targetWork: this.selectedWorkTarget?.target_works_id,
                    material: this.selectedMaterial?.id,
                    value: this.value,
                    limit: this.limit
                }
                this.$store.dispatch(`editMaterialTargets`, data)
                    .then(() => this.$store.dispatch(`getMaterialTargets`));
            }
        },
        name: "EditMaterialTarget"
    }
</script>

<style scoped>

</style>
